<template>
  <div class="risk-assessment-row-wrapper">
    <div class="risk-assessment-row-item">
      <v-layout
        :id="`post-assessment-selection-${contentItem.name}`"
        class="flex items-center gap-3 risk-assessment-row"
      >
        <v-icon
          v-if="isChecklist && !contentItem.isNoRisk"
          :size="20"
          color="primary"
          class="item-checkbox"
          @click.stop="emitSelect"
        >
          {{ checkboxIcon }}
        </v-icon>

        <v-icon :color="headerIconColor" class="triage-icon" small>{{ mdiCircle }}</v-icon>

        <div>
          <div style="line-height: normal">
            <mrx-translation
              v-if="contentItem.headerToken"
              class="treatment-header"
              :token="contentItem.headerToken"
            />

            <div
              v-for="(item, index) in contentItem.detailContent || []"
              :key="`${item}_${index}`"
            >
              <mrx-translation
                v-if="!contentItem.useHTMLFormat"
                class="assessment-light"
                :class="contentItem.headerToken ? 'treatment-text' : 'treatment-header'"
                :token="item"
              />
              <span
                v-else
                class="assessment-light"
                :class="contentItem.headerToken ? 'treatment-text' : 'treatment-header'"
                v-html="item"
              ></span>
            </div>
          </div>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<script lang="ts">
import MrxTranslation from "@/components/thinkmd/mrx/translation.vue";
import { mdiCircle } from "@mdi/js";
import { defineComponent, PropType } from "vue";
import { ContentItem } from "../../types/overall-assessment.types";

export default defineComponent({
  name: "RiskAssessmentRow",
  components: { MrxTranslation },
  emits: ["select"],
  props: {
    contentItem: {
      type: Object as PropType<ContentItem>,
      required: true,
    },
    headerToken: {
      type: String,
      default: "",
    },
    headerIconColor: {
      type: String,
      default: "",
    },
    isChecklist: {
      type: Boolean,
      default: false,
    },
    checkboxIcon: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const emitSelect = (): void => {
      emit("select", props.contentItem.name);
    };

    return {
      mdiCircle,
      emitSelect,
    };
  },
});
</script>
